import { render, staticRenderFns } from "./ApplyRuleFromStrategyModal.vue?vue&type=template&id=53d4fa0d&"
import script from "./ApplyRuleFromStrategyModal.vue?vue&type=script&lang=ts&"
export * from "./ApplyRuleFromStrategyModal.vue?vue&type=script&lang=ts&"
import style0 from "./ApplyRuleFromStrategyModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports